export default (state: any, action: any) => {
  const { history, latestHistory, details } = action.payload;
  switch (action.type) {
    case "SET_PAYMENT_HISTORY":
      return {
        ...state,
        history
      };
    case "SET_LATEST_PAYMENT_HISTORY":
      return {
        ...state,
        latestHistory
      };
    case "SET_PAYMENT_DETAILS":
      return {
        ...state,
        details,
      };
    default:
      return state;
  }
};
